/** @todo remove this for obvious reasons */
export function useIsViewingAsFromCompany() {
  return true
}
